import styled from '@emotion/styled';
import { sizes } from '@sharefiledev/antd-config';
import { GlobalToken, Modal } from 'antd';

export const StyledModal = styled(Modal)<{
	token: GlobalToken;
}>`
	.ant-modal-content {
		padding: ${sizes.XL} ${sizes.LG};

		@media (max-width: ${props => props.token.screenXS}px) {
			padding: ${sizes.XL} ${sizes.MS};
			margin: ${sizes.base};
			width: fit-content !important;
		}
	}

	@media (max-width: ${props => props.token.screenMD}px) {
		max-width: calc(100vw - ${sizes.XL}) !important;
	}
`;
